<section class="banner services-banner">
  <div class="container mx-auto ">
    <div class="text-center">
      <h1 class="title-heading !text-white"  data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600">Services</h1>
      <p class="text-white mt-3 font-medium"  data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">Tailored Travel Solutions
        for Every Need
      </p>

    </div>
  </div>
</section>
<section class="">
  <div class="container ps-4  border-l border-l-gray-300 ">
    <div class="grid lg:grid-cols-2 gap-4 comprehensive-wrap">
      <div class="">
        <h2 class="title-sub !text-gray-900"  data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">Comprehensive<br> Travel Solutions for</h2>
        <h3 class="title-sub !font-normal mb-2"  data-sal="slide-down" data-sal-duration ='500' data-sal-delay="500">Businesses and Individuals</h3>
        <p  data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600">we offer a complete range of travel services designed to meet the diverse needs of corporate and
          leisure travelers alike.</p>
      </div>
      <div class="comprehensive-img"  data-sal="fade" data-sal-duration ='500' data-sal-delay="600">
        <img src="assets/images/cap-logo.png" class="absolute bottom-0 right-0"
             alt="Comprehensive Travel Solutions logo" loading="lazy">
      </div>
    </div>
  </div>
</section>
<section class="">
  <div class="container ps-4  border-l border-l-gray-300 section-top-pad section-bottom-pad">
    <div class="text-center section-top-mar">
      <span class="title-tag-line" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Comprehensive</span>
      <h2 class="title-sub mt-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="700">Travel Services for Every Journey</h2>
      <p class="font-normal" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="800">Umbrella Travel, we offer a wide range of travel services to meet the diverse
        needs of both businesses and individual travelers. Whether you’re managing corporate travel or
        planning a personal vacation, we provide customized solutions to ensure a smooth, stress-free, and
        memorable travel experience.</p>
    </div>
    <div class="services-wrapper section-top-pad ">
      <div class="services-box section-top-pad">
        <div class="services-img order-2 lg:order-1">
          <img src="assets/images/management.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
        <div class="service-content order-2 lg:order-1">
          <h3 class="font-semibold text-xl text-orange-500 mb-3"  data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Management</h3>
          <p  data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">We handle everything from booking flights, hotels, and ground transportation to managing
            travel policies and expenses. </p>
        </div>
      </div>
      <div class="services-box reverse section-top-pad">
        <div class="service-content order-2 lg:order-1">
          <h3 class="font-semibold text-xl text-orange-500 mb-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Technology</h3>
          <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">Leverage the power of cutting-edge technology with our intuitive booking platforms and
            real-time traveler tracking tools. </p>
        </div>
        <div class="services-img order-1 lg:order-2">
          <img src="assets/images/technology.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
      </div>
      <div class="services-box section-top-pad">
        <div class="services-img">
          <img src="assets/images/consultant.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
        <div class="service-content">
          <h3 class="font-semibold text-xl text-orange-500 mb-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Consulting</h3>
          <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">Our experienced consultants help businesses optimize their travel programs by offering
            strategic advice, policy development, and vendor negotiations.</p>
        </div>
      </div>
      <div class="services-box reverse section-top-pad">
        <div class="service-content order-2 lg:order-1">
          <h3 class="font-semibold text-xl text-orange-500 mb-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Booking</h3>
          <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">We simplify corporate travel bookings by offering a one-stop solution for air travel,
            accommodation, and ground transportation.</p>
        </div>
        <div class="services-img order-1 lg:order-2">
          <img src="assets/images/booking.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
      </div>
      <div class="services-box section-top-pad">
        <div class="services-img">
          <img src="assets/images/reporting.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
        <div class="service-content">
          <h3 class="font-semibold text-xl text-orange-500 mb-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Reporting</h3>
          <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">Get detailed insights into your travel spending with our corporate travel reporting services.
          </p>
        </div>
      </div>
      <div class="services-box reverse section-top-pad">
        <div class="service-content order-2 lg:order-1">
          <h3 class="font-semibold text-xl text-orange-500 mb-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Leisure</h3>
          <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">We also cater to personal travel needs, helping you plan the perfect getaway. Whether you're
            looking for relaxation or adventure, our leisure travel services.</p>
        </div>
        <div class="services-img order-1 lg:order-2">
          <img src="assets/images/leisure.png" alt="Travel Management" loading="lazy" data-sal="zoom-out" data-sal-duration ='500' data-sal-delay="300">
        </div>
      </div>

    </div>

  </div>
</section>
<section class="why-choose-us">
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad section-bottom-pad">
    <div class="grid lg:grid-cols-2 items-center">
      <div class="why-left">
        <span class="title-tag-line inline-flex !text-white" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">Why Choose</span>
        <h2 class="title-sub  mt-3" data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">Umbrella  Travel?</h2>
        <p class="text-blue-950" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="700">Umbrella Travel, we go beyond simple bookings to provide comprehensive travel management solutions tailored to your unique needs. </p>

      </div>
      <div class="why-right">
        <ul class="space-y-7 text-sm">
          <li class="flex gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Personalized Solutions</h2>
              <p>We create customized travel management strategies that align with your business
                objectives.</p>
            </div>
          </li>

          <li class="flex gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="400">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Cost Savings</h2>
              <p>Our negotiation skills and industry partnerships allow us to secure the best deals
                for our clients.</p>
            </div>
          </li>
          <li class="flex gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Expertise Across Industries</h2>
              <p>From corporate travel to government, SMMEs, and the film industry, we are equipped to
                handle a variety of complex travel needs.</p>
            </div>
          </li>
          <li class="flex gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]"
                 alt="">
            <div>
              <h2 class="title-second-sub">Real-Time Insights</h2>
              <p>Access cutting-edge technology that offers real-time updates and reporting for
                complete visibility over your travel management.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
